import mutations from './worklistDeliveryNote.mutations'
import actions from './worklistDeliveryNote.actions'
import getters from './worklistDeliveryNote.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
